import { RefObject, useEffect } from 'react';

export const useListenTransitionEnd = <T extends HTMLElement = HTMLElement>(targetRef: RefObject<T>, callback: (e: TransitionEvent, target: T) => void, ...deps: any[]) => {
  const target = targetRef.current;
  useEffect(() => {
    if (target == null) return;

    if (!('ontransitionend' in target)) {
      const id = requestAnimationFrame(() => {
        callback(new TransitionEvent('transitionend'), target);
      });
      return () => cancelAnimationFrame(id);
    }

    const listener: EventListener = (e: Event) => {
      callback(e as TransitionEvent, target);
    }
    target.addEventListener('transitionend', listener);
    return () => target.removeEventListener('transitionend', listener);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target, ...deps]);
}
